import React, {useState, useCallback, useMemo, useEffect, useRef} from 'react';
import ReactFlow, { MiniMap, Controls, Background, Panel, useNodesState, useEdgesState, addEdge } from 'reactflow';
import generateEdgesByNodeIds from '../flowsPreview/generateEdges';
import 'reactflow/dist/style.css';
import './style.css';

// Define node configuration with action types, labels and icons
const nodeConfig = {
  SendEmail: { label: 'Email', icon: '📧' },
  SendSMS: { label: 'SMS', icon: '📱'},
  TimeGap: { label: 'Time Gap', icon: '⏱️' }
};

// Convert config to array format for components that need it
const nodeOptions = Object.entries(nodeConfig).map(([action, config]) => ({
  id: action,
  label: config.label,
  icon: config.icon
}));

const FlowsPreviewPanel = ({nodes, setNodes, setEdges, setLayoutType, selectedNodes,
    selectedAction, setSelectedAction}) => {

        
    // Function to create a new node with the selected shape
    const addNodeWithSelectedShape = () => {
        const newNode = {
            id: `node-${nodes.length + 1}`,
            type: 'flowNode',
            position: { x: 250, y: 250 },
            data: { 
                label: `New Email`,
                shape: "rounded-rect-large"
            }
        };
        
        setNodes((nds) => nds.concat(newNode));
    };

    // Function to delete selected nodes
    const deleteSelectedNodes = () => {
        if (selectedNodes.length === 0) return;
        
        const selectedIds = selectedNodes.map(node => node.id);
        
        // Create a copy of nodes to work with
        let updatedNodes = [...nodes];
        
        // For each selected node that will be deleted
        selectedNodes.forEach(selectedNode => {
            const childrenIds = selectedNode.data.children || [];
            const parentId = selectedNode.data.parent;
            
            // For each child, connect it to the grandparent
            childrenIds.forEach(childId => {
                const childNodeIndex = updatedNodes.findIndex(node => node.id === childId);
                if (childNodeIndex !== -1) {
                    // Update the parent to the grandparent
                    updatedNodes[childNodeIndex] = {
                        ...updatedNodes[childNodeIndex],
                        parent: parentId // Connect to grandparent instead of setting to null
                    };
                }
            });
            
            // If the node has a parent, update the parent's children list
            if (parentId) {
                const parentNodeIndex = updatedNodes.findIndex(node => node.id === parentId);
                if (parentNodeIndex !== -1) {
                    const parentNode = updatedNodes[parentNodeIndex];
                    // Remove the current node from parent's children
                    let updatedChildren = (parentNode.data.children || []).filter(id => id !== selectedNode.id);
                    
                    // Add the current node's children to the parent's children
                    updatedChildren = [...updatedChildren, ...childrenIds];
                    
                    updatedNodes[parentNodeIndex] = {
                        ...parentNode,
                        children: updatedChildren
                    };
                }
            }
        });
        
        // Filter out the selected nodes
        updatedNodes = updatedNodes.filter((node) => !selectedIds.includes(node.id));
        
        setNodes(updatedNodes);
        
        // Regenerate edges for the remaining nodes
        setEdges(generateEdgesByNodeIds(updatedNodes));
    };

    // Function to change layout
    const changeLayout = (type) => {
        setLayoutType(type);
      };


    // Function to handle shape selection
    const handleShapeSelection = (shapeId) => {
        setSelectedAction(shapeId);
    };


    return (
        <Panel position="top-left" style={{ position: 'absolute' }} className="control-panel">
            <button
                className="control-button"
                onClick={addNodeWithSelectedShape}
            >
                Add Node
            </button>
            <button
                className="control-button"
                onClick={deleteSelectedNodes}
                disabled={selectedNodes.length === 0}
            >
                Delete Selected
            </button>
            
            <div className="shape-selector">
                <div className="shape-selector-title">Select Node Shape</div>
                <div className="shape-options-container">
                    {nodeOptions.map((shape) => (
                        <div
                            key={shape.id}
                            className={`shape-option ${selectedAction === shape.id ? 'selected' : ''}`}
                            onClick={() => handleShapeSelection(shape.id)}
                        >
                            <span className="shape-icon">{shape.icon}</span>
                            <span className="shape-label">{shape.label}</span>
                        </div>
                    ))}
                </div>
            </div>
            
            <div style={{ marginTop: '10px' }}>
                <button className="control-button" onClick={() => changeLayout('vertical')}>Potrait View</button>
                <button className="control-button" onClick={() => changeLayout('horizontal')}>Landscape View</button>
            </div>

            <button 
                onClick={() => {
                    // Generate a unique ID
                    const id = `branching-${Date.now()}`;
                    
                    // Create a new branching node
                    const newNode = {
                        id,
                        type: 'branchingNode',
                        position: { x: 100, y: 100 },
                        data: { 
                            label: 'Condition Node',
                            action: 'SMS',
                            parent: null,
                            children: [],
                            branchesInitialized: false
                        }
                    };
                    
                    // Add the node to the flow
                    setNodes(nodes => [...nodes, newNode]);
                }}
            >
                Add Branching Node
            </button>
        </Panel>
    );
}
export default FlowsPreviewPanel;